module.exports = __webpack_public_path__ + "img/iconfinder_Rounded_Twitter5_svg_5282551.155865a0.svg";